var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:replace"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.833 9.16667V6.66667C17.833 6.22464 17.6574 5.80072 17.3449 5.48816C17.0323 5.17559 16.6084 5 16.1663 5H11.1663M11.1663 5L13.6663 7.5M11.1663 5L13.6663 2.5M2.83301 10.8333V13.3333C2.83301 13.7754 3.0086 14.1993 3.32116 14.5118C3.63372 14.8244 4.05765 15 4.49967 15H9.49967M9.49967 15L6.99967 12.5M9.49967 15L6.99967 17.5M2.83301 3.33333C2.83301 3.11232 2.92081 2.90036 3.07709 2.74408C3.23337 2.5878 3.44533 2.5 3.66634 2.5H6.99967C7.22069 2.5 7.43265 2.5878 7.58893 2.74408C7.74521 2.90036 7.83301 3.11232 7.83301 3.33333V6.66667C7.83301 6.88768 7.74521 7.09964 7.58893 7.25592C7.43265 7.4122 7.22069 7.5 6.99967 7.5H3.66634C3.44533 7.5 3.23337 7.4122 3.07709 7.25592C2.92081 7.09964 2.83301 6.88768 2.83301 6.66667V3.33333ZM12.833 13.3333C12.833 13.1123 12.9208 12.9004 13.0771 12.7441C13.2334 12.5878 13.4453 12.5 13.6663 12.5H16.9997C17.2207 12.5 17.4327 12.5878 17.5889 12.7441C17.7452 12.9004 17.833 13.1123 17.833 13.3333V16.6667C17.833 16.8877 17.7452 17.0996 17.5889 17.2559C17.4327 17.4122 17.2207 17.5 16.9997 17.5H13.6663C13.4453 17.5 13.2334 17.4122 13.0771 17.2559C12.9208 17.0996 12.833 16.8877 12.833 16.6667V13.3333Z",
    stroke: "#9FA1A2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.35c6156b0f6b335aa27b4b88156b645c.svg";
export { ForwardRef as ReactComponent };